module.exports = __webpack_public_path__ + "static/media/returnedstamp.598d2a20.svg";